import { createContext } from 'react';

const StickyAlertContext = createContext();
export default StickyAlertContext;
